module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('ConversionsTabs'), _vm._v(" "), _c('StatisticTable', {
    staticClass: "animated fadeIn",
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.conversions')))
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-555de7df"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/conversions/Period.vue
// module id = 557
// module chunks = 0